export default function InputEmail() {
    return {
        restrict: "E",

        scope: {
            form: "=",
            model: "=",
            validation: "=",
            label: "=",
            checkUnique: "<",
            role: "<",
        },

        template: require("./template.html"),

        controller: function ($scope, $q, Users, $timeout) {
            const emailOnLoad = angular.copy($scope.model.email);

            $timeout(() => {
                // wait for the form to be ready
                addCustomValidationMessageObj(
                    "email",
                    "required",
                    "Feltet skal udfyldes"
                );
                addCustomValidationMessageObj(
                    "email",
                    "email",
                    "Husk at E-mailen skal indeholde @ - (fx dig@domæne.dk)"
                );
            });

            $scope.$watch(
                "role",
                function () {
                    // Validate if it's a KK mail (72 = Københavns Kommune – intern)
                    if (
                        $scope.model.email &&
                        $scope.role != null &&
                        $scope.role.id == 72
                    ) {
                        if (!isValidKKMail($scope.model.email)) {
                            return;
                        }
                    }
                },
                true
            );

            $scope.checkMailUnique = (email) => {
                setValidity(true);
                setUserMessage("");

                // Validate if it's a KK mail (72 = Københavns Kommune – intern)
                if (email && $scope.role != null && $scope.role.id == 72) {
                    if (!isValidKKMail(email)) {
                        return;
                    }
                }

                /**
                 * only check if user enters a new email
                 */
                if (email && email !== emailOnLoad) {
                    $q.all({
                        email: Users.emailCheck(email),
                        username: Users.usernameCheck(email),
                    }).then(
                        (res) => {
                            if (
                                res.email.isAvailable &&
                                res.username.isAvailable
                            ) {
                                setValidity(true);
                                setUserMessage("");
                            } else {
                                setValidity(false);
                                setUserMessage(
                                    "Den indtastede email findes allerede."
                                );
                            }
                        },
                        (err) => {
                            setValidity(false);
                            setUserMessage("Error : " + err.statusText);
                        }
                    );
                }
            };

            const isValidKKMail = (email) => {
                if (!/kk.dk\s*$/.test(email.toLowerCase())) {
                    setValidity(false);
                    setUserMessage("Du skal benytte din KK e-mail.");
                    return false;
                }
                return true;
            };
            const addCustomValidationMessageObj = (field, type, message) => {
                if ($scope.form.email.customErrorMessages === undefined) {
                    $scope.form.email.customErrorMessages = [];
                }

                $scope.form[field].customErrorMessages.push({
                    field: field,
                    type: type,
                    message: message,
                    label: $scope.label,
                });
            };
            const setValidity = (bool) => {
                $scope.form.email.$setValidity("isUnique", bool);
            };

            const setUserMessage = (str) => {
                if (str) {
                    addCustomValidationMessageObj("email", "isUnique", str);
                }
                $scope.form.email.serverMessage = str;
            };

            $scope.validationCheck = function () {
                // $scope.form.email.$valid = true;
            };
        },
    };
}
